module.exports = __webpack_public_path__ + "static/img/cstSer_bg_08.96c0e9d4.svg";